module.exports = __webpack_public_path__ + "media/Cube.c9b78db7.mp4";